import { navigateBack } from "@/services/navigation-history";

/**
 * Minimal router interface representing the navigation actions used by navigation helpers.
 */
export interface INavigator {
  canGoBack: () => boolean;
  back: () => void;
  navigate: (href: any, options?: any) => void;
  replace: (href: any, options?: any) => void;
}

/**
 * Minimal navigation interface for React Navigation screen navigation props.
 */
export interface INavigationProp {
  canGoBack?: () => boolean;
  goBack?: () => void;
  getParent?: (id?: string) => any;
  getState?: () => any;
}

/**
 * Navigates back to the previous screen in history ("where it came from").
 * If there is no previous page in history, falls back to the designated list route.
 *
 * @param {INavigator} router - The navigation instance (such as useRouter() from expo-router).
 * @param {string} fallbackListRoute - The fallback route to the item list screen (e.g. "/(tabs)/my-memories" or "/my-memories").
 * @param {INavigationProp} [navigation] - Optional React Navigation prop (from useNavigation()) to inspect stack/tab history.
 */
export function navigateBackOrToList(
  router: INavigator,
  fallbackListRoute: string,
  navigation?: INavigationProp,
): void {
  navigateBack(router, navigation, undefined, fallbackListRoute);
}

